/**
 * Task Queries - Query builders para tarefas
 */
import { supabase } from '../../../lib/supabase';

/**
 * Retorna a data de hoje normalizada (meia-noite)
 */
export function getNormalizedToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
}
/**
 * Select string com todas as relações necessárias para exibição de tarefas
 */
const TASK_SELECT_WITH_RELATIONS = `
    *,
    opportunities:opportunity_id (
        id, 
        title,
        contacts (
            id,
            name,
            phone,
            email
        )
    ),
    profiles!assigned_to (
        id, 
        full_name, 
        avatar_url
    )
`;

/**
 * Query base para tarefas ordenadas por data de vencimento
 * Inclui relações com opportunities (negociações), contacts e profiles (usuário atribuído)
 */
export function baseTaskQuery() {
    return supabase
        .from('tasks')
        .select(TASK_SELECT_WITH_RELATIONS)
        .order('due_date', { ascending: true });
}

/**
 * Query para tarefas pendentes
 */
export function pendingTasksQuery() {
    return supabase
        .from('tasks')
        .select(TASK_SELECT_WITH_RELATIONS)
        .eq('is_completed', false)
        .order('due_date', { ascending: true });
}

/**
 * Query para tarefas atrasadas
 */
export function overdueTasksQuery() {
    const today = getNormalizedToday();
    return supabase
        .from('tasks')
        .select(TASK_SELECT_WITH_RELATIONS)
        .eq('is_completed', false)
        .lt('due_date', today.toISOString())
        .order('due_date', { ascending: true });
}

/**
 * Query para tarefas de hoje
 */
export function dueTodayTasksQuery() {
    const today = getNormalizedToday();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    return supabase
        .from('tasks')
        .select(TASK_SELECT_WITH_RELATIONS)
        .eq('is_completed', false)
        .gte('due_date', today.toISOString())
        .lt('due_date', tomorrow.toISOString())
        .order('due_date', { ascending: true });
}

/**
 * Query para tarefas dos próximos 3 dias
 */
export function dueSoonTasksQuery() {
    const today = getNormalizedToday();
    const threeDaysFromNow = new Date(today);
    threeDaysFromNow.setDate(threeDaysFromNow.getDate() + 3);

    return supabase
        .from('tasks')
        .select(TASK_SELECT_WITH_RELATIONS)
        .eq('is_completed', false)
        .gte('due_date', today.toISOString())
        .lte('due_date', threeDaysFromNow.toISOString())
        .order('due_date', { ascending: true });
}

/**
 * Query para contagem de tarefas pendentes
 */
export function countPendingQuery() {
    return supabase
        .from('tasks')
        .select('*', { count: 'exact', head: true })
        .eq('is_completed', false);
}

/**
 * Query para contagem de tarefas atrasadas
 */
export function countOverdueQuery() {
    const today = getNormalizedToday();
    return supabase
        .from('tasks')
        .select('*', { count: 'exact', head: true })
        .eq('is_completed', false)
        .lt('due_date', today.toISOString());
}
